module.exports = __webpack_public_path__ + "static/img/cxmx.c092ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/cxmx.png
// module id = mFFy
// module chunks = 1